import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedMarker } from '@vis.gl/react-google-maps';
import { getSelectedPosition } from '@selectors/search';

const SearchMarker = () => {
  const position = useSelector(getSelectedPosition);

  if (position) {
    return <AdvancedMarker position={position} zIndex={15} />;
  }
  return null;
};

export default memo(SearchMarker);
